import { processCorrelations } from "@/_core/data/api_calls/relatives_values/correlations/processCorrelations";

/**
 * Retrieves correlation data for currencies relative values
 * @param {object} ctx: context variables
 */
export function getCurrencyCorrelations(ctx) {
  let params = {
    method: "GET",
    endpoint: "relatives_values_historical",
    content_type: "application/json",
    query_params: {
      format: "json",
      currency: ctx.currencyNumber,
      correlations: true
    }
  };
  return processCorrelations(ctx, params);
}
